import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"font-size":"large"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]


import { LIcon, LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import { Mooring } from "@/models/Mooring";
import { decimalPos2DDM } from "@/services/position";


export default /*#__PURE__*/_defineComponent({
  __name: 'MooringMarker',
  props: {
  mooring: {
    type: Mooring,
    required: true,
  },
  show: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



function getDiv(name: string): HTMLElement {
  let elem = document.createElement("div");
  elem.className = "mooring-label";
  elem.innerText = name;
  return elem;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(LMarker), {
      latLng: __props.mooring.pos
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(LIcon), {
          className: __props.show ? `show` : `noshow`,
          iconUrl: 
        __props.mooring.type == 'nyyc'
          ? `img/bouy_nyyc.png`
          : `img/bouy_${__props.mooring.color}.png`
      ,
          iconSize: [28, 25],
          iconAnchor: [13, 22]
        }, null, 8, ["className", "iconUrl"]),
        _createVNode(_unref(LTooltip), { direction: "left" }, {
          default: _withCtx(() => [
            _createElementVNode("b", _hoisted_1, _toDisplayString(__props.mooring.name), 1),
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_unref(decimalPos2DDM)(__props.mooring.pos.lat, true)) + " ", 1),
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_unref(decimalPos2DDM)(__props.mooring.pos.lng, false)) + " ", 1),
            _hoisted_4,
            (__props.mooring.size)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Max length: " + _toDisplayString(__props.mooring.size) + "'", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              innerHTML: __props.mooring.bearings.join('<br />')
            }, null, 8, _hoisted_6),
            _createElementVNode("div", null, _toDisplayString(__props.mooring.directions), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["latLng"]),
    _createVNode(_unref(LMarker), {
      latLng: __props.mooring.pos
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(LIcon), {
          html: getDiv(__props.mooring.name),
          className: __props.show ? `show` : `noshow`
        }, null, 8, ["html", "className"])
      ]),
      _: 1
    }, 8, ["latLng"])
  ], 64))
}
}

})